<template>
  <div class="layout">
    <div class="header">
      <img src="../assets/logo-02.png" alt="" width="160" srcset="" class="logo" @click="$router.push('/')" />
      <el-popover placement="bottom-start" :width="100" trigger="click" v-if="login">
        <template #reference>
          <div class="user"> 欢迎您，{{ name }}</div>
        </template>
        <div class="user-popover">
          <div class="quit" @click="quit">退出登录</div>
        </div>
      </el-popover>
      <!-- <div class="user" v-else> 请先登录</div> -->
    </div>
    <router-view v-on:getUser="getUser"></router-view>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import Cookies from 'js-cookie';

// @ is an alias to /src

export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      name: '',
      login: false
    };
  },
  methods: {
    getUser(name) {
      this.login = true;
      this.name = name;
    },
    quit() {
      ElMessage.success('账号已退出')
      Cookies.remove('session');
      localStorage.removeItem('session_id');
      localStorage.removeItem('token');
      localStorage.removeItem('pkuseUser');
      this.name = '';
      this.login = false;
    }
  }
};
</script>

<style scoped lang="scss">
.layout {
  width: 100vw;
  height: 100vh;
  background: url("../assets/home3.png");
  background-size: 100% 100%;
  overflow-y: auto;
}

.logo {
  // width: 210px;
  // height: 35px;
  margin-left: 40px;
}

.header {
  position: relative;
  box-sizing: border-box;
  height: 3.5rem;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  background: #e6ecfda3;
  border-bottom: 2px solid white;
  height: 90px;
  padding-left: 20%;
}

.user {
  width: 200px;
  // height: 40px;
  padding-right: 151px;
  // padding-top: 20px;
  // margin-top: 8px;
}

// .user-popover{
//   padding: 20px;
// }

.quit {
  cursor: pointer;
}
</style>